module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/InfluencerExample/1_icon-b6f52237b01e9a9be00994bbdcb23e74.png";